import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SellerNewsService {
  constructor(private http: HttpClient) {}

  public get() {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/user/seller_news`,
    );
  }

  public create(data): Observable<any> {
    return this.http.post<any>(
      `${environment.api_url_v1}/services/user/seller_news`,
      data,
    );
  }

  public update(data): Observable<any> {
    return this.http.put<any>(
      `${environment.api_url_v1}/services/user/seller_news`,
      data,
    );
  }

  public delete(id): Observable<any> {
    return this.http.delete<any>(
      `${environment.api_url_v1}/services/user/seller_news/${id}`,
    );
  }

  public getSellerNews(id): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/user/seller_news?company_id=${id}`,
    );
  }
}
